import React from 'react';
import PropTypes from 'prop-types';

import { InputWrapper } from './css';
import Note from '../../note';

const FieldTextNote = ({ data }) => {
  const { note, isWarningMessage, isShowNoteBackground } = data;
  return (
    <InputWrapper>
      {note && note.content && (
        <Note
          type="richText"
          data={note}
          isWarningMessage={isWarningMessage}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
    </InputWrapper>
  );
};

FieldTextNote.propTypes = {
  data: PropTypes.shape({
    note: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    isWarningMessage: PropTypes.bool.isRequired,
    isShowNoteBackground: PropTypes.bool.isRequired
  }).isRequired
};

export default FieldTextNote;
